import React from "react";
import "./Assistance.css";
import Wave from "../../../../assets/images/assistance-wave.png";
import Star from "../../../../assets/icons/assistance-star.svg";
import Card1 from "../../../../Components/Cards/Card1";
import Accuracy from "../../../../assets/images/assistance-accuracy.png";
import Headphone from "../../../../assets/images/assistance-headphone.png";
import Person from "../../../../assets/images/assistance-person.png";
const Assistance = () => {
  return (
    <div className="assistance__section">
      <img src={Wave} className="assistance__section_wave" />
      <div className="assistance__section_heading">
        <span className="assistance__section_headingblack">W4</span>{" "}
        <span className="assistance__section_headinggreen">Assistance</span>
        <div className="assistance__section_options">
          <div className="assistance__section_option">
            <div className="assistance__section_optionicon">
              <img src={Star} />
            </div>
            <div className="assistance__section_optiontext">Got married?</div>
          </div>
          <div className="assistance__section_option">
            <div className="assistance__section_optionicon">
              <img src={Star} />
            </div>
            <div className="assistance__section_optiontext">Had a baby?</div>
          </div>
          <div className="assistance__section_option">
            <div className="assistance__section_optionicon">
              <img src={Star} />
            </div>
            <div className="assistance__section_optiontext">
              Changed employee?
            </div>
          </div>
          <div className="assistance__section_option">
            <div className="assistance__section_optionicon">
              <img src={Star} />
            </div>
            <div className="assistance__section_optiontext">
              Any salary bonuses?
            </div>
          </div>
        </div>
        <p className="assistance__section_desc">
          Serene Tax can help find you any new tax deductions and credits
          personalized to you and your unique changes to be done in your w2.
        </p>
        <div className="assistance__section_cards">
          <div className="assistance__section_card">
            <Card1
              image={Accuracy}
              dotColor="#8CC0FF"
              backgroundColor="rgba(0, 142, 255, 0.15)"
              heading="100% Accuracy"
              description="We offer strategic advantages that are totally unmatched and signify our service by providing accurate tax return. Our paperwork is accurate and always up to date."
            />
          </div>
          <div className="assistance__section_card">
            <Card1
              image={Headphone}
              dotColor="#9CE19B"
              backgroundColor="rgba(20, 176, 130, 0.15)"
              heading="Personal Assistance"
              description="We provide personalized secretarial and administrative support in a well-organized and timely manner and handle request or queries appropriately."
            />
          </div>
          <div className="assistance__section_card">
            <Card1
              image={Person}
              dotColor="#7AB7FF"
              backgroundColor="rgba(122, 67, 238, 0.1)"
              heading="Guidance in case of an audit"
              description="Every personal Serene Tax return is backed by our Audit Support Guarantee for free one-on-one audit guidance from a trained tax professional."
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Assistance;
